module.exports = __webpack_public_path__ + "media/images/top-content-img-11-33912089c0061a597325ff6ed7d2d56e.jpg";